import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {ADD_TO_CART_EVENT, CLOSE_EVENT} from '@dcp/configurator';

@Component({
  selector: 'dcp-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('iFrame', {static: false}) iframeComponent: ElementRef;
  @Input() title: string;
  @Input() show: boolean = false;
  @Input() url: string;

  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  private messageHandler: (payload: any) => void = (payload) => {
    if (payload.data?.eventId === CLOSE_EVENT) {
      this.closeIframe();
    } else if (payload.data?.eventId === ADD_TO_CART_EVENT) {
      this.addToCartIframe();
    }
  };

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
  ) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('message', this.messageHandler, false);
    }
  }

  ngOnChanges(): void {
    if (this.show) {
      setTimeout(() => {
        this.iframeComponent.nativeElement.focus();
      }, 0);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('message', this.messageHandler, false);
    }
  }

  closeIframe(): void {
    this.closeEvent.emit(false);
  }

  addToCartIframe(): void {
    setTimeout(() => {
      this.closeEvent.emit(true);
    }, 1000);
  }
}
